import { render, staticRenderFns } from "./ICO.vue?vue&type=template&id=70003ad8&scoped=true&"
import script from "./ICO.vue?vue&type=script&lang=js&"
export * from "./ICO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70003ad8",
  null
  
)

export default component.exports